import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();

  const menuItems = [
    {
      name: "ડેશબોર્ડ",
      path: "/vaibhavlaxmiMyAdmin/dashboard",
      icon: "bi-speedometer2",
    },

    {
      name: "ટીમ મેનેજ કરો",
      path: "/vaibhavlaxmiMyAdmin/team",
      icon: "bi-people-fill",
    },

    // { name: "સેવાઓ મેનેજ કરો", path: "/admin/services", icon: "bi-briefcase-fill" },

    {
      name: "સંપર્ક માહિતી બદલો",
      path: "/vaibhavlaxmiMyAdmin/contactus",
      icon: "bi-telephone-fill",
    },

    {
      name: "સંપર્કો જુઓ",
      path: "/vaibhavlaxmiMyAdmin/contactinfo",
      icon: "bi-chat-dots-fill",
    },

    {
      name: "અમારા વિશે મેનેજ કરો",
      path: "/vaibhavlaxmiMyAdmin/about",
      icon: "bi-info-circle-fill",
    },

    {
      name: "પ્રવૃત્તિઓનું સંચાલન કરો",
      path: "/vaibhavlaxmiMyAdmin/activities",
      icon: "bi-activity",
    },

    {
      name: "રજા નું સંચાલન કરો",
      path: "/vaibhavlaxmiMyAdmin/holiday",
      icon: "bi-calendar-check-fill",
    },

    {
      name: "નવી માહિતી ઉમેરો",
      path: "/vaibhavlaxmiMyAdmin/news",
      icon: "bi-newspaper",
    },

    {
      name: "લોગઆઉટ",
      path: "/vaibhavlaxmiMyAdmin/logout",
      icon: "bi-box-arrow-right",
    },
  ];

  return (
    <div className="sidebar">
      <h2 className="logo">એડમિન પેનલ</h2>

      <ul className="menu">
        {menuItems.map((item) => (
          <li key={item.name}>
            <Link
              to={item.path}
              className={location.pathname === item.path ? "active" : ""}
            >
              <i className={`bi ${item.icon}`}></i>
              <span>{item.name}</span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="logout-section"></div>
    </div>
  );
}
